import React from "react";
import { observer } from "mobx-react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { Send } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { PrimaryButton, RegularButton, SpinnerOverlay } from "@components";
import { EmailEditorDialogStore } from "./EmailEditorDialogStore";
import EmailEditorForm from "./EmailEditorForm";

type Props = {
  store: EmailEditorDialogStore;
};

const EmailEditorDialog: React.FC<Props> = (props) => {
  const { store } = props;
  const { emailOptions } = store;

  return (
    <Dialog
      open={store.isOpen}
      fullWidth
      maxWidth="md"
      TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
    >
      <DialogTitle>{locale.SendEmail}</DialogTitle>

      <DialogContent>
        <EmailEditorForm store={store} {...emailOptions} />
      </DialogContent>

      <DialogActions>
        <RegularButton onClick={store.onCancel}>{locale.Close}</RegularButton>

        <PrimaryButton
          leftIcon={<Send />}
          onClick={store.submit}
          disabled={!store.canSubmit}
        >
          {locale.Send}
        </PrimaryButton>
      </DialogActions>

      <SpinnerOverlay show={false} />
    </Dialog>
  );
};

export default observer(EmailEditorDialog);
